export const noteCellInnerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};
